import React from "react";
import delivery from "../assets/svgs/scooter.svg";
import { ArrowLeft, ArrowRight, Phone, MapPin, Sun, Moon } from "lucide-react";

const Delivery = ({ deliveryData, currencySymbol }) => {
  if (!deliveryData) return null;
  const getFullAddress = [deliveryData?.address_2]
    .filter(Boolean)
    .join(", ");
  const lat = deliveryData?.latitude;
  const lng = deliveryData?.longitude;

  const mapSrc =
    lat && lng
      ? `https://www.google.com/maps?q=${lat},${lng}&hl=en&z=15&output=embed`
      : "";

  return (
    <>
      <div className="max-w-7xl mx-auto p-4 mt-8">
        <div>
          <div className="border border-[#E5E5E5] rounded-2xl p-4 md:p-10">
            <h1 className="text-2xl sm:text-3xl font-bold mb-4 font-outfit">
              Delivery Information
            </h1>

            <div className="flex items-start gap-4 sm:gap-5 mb-8">
              <MapPin size={20} />
              <p className="text-[#191919] text-base">{getFullAddress}</p>
            </div>

            <div className="flex flex-col md:flex-row gap-4">
              {/* Map Box */}
              <div className="flex-1 h-[160px]  rounded-xl overflow-hidden shadow-md">
                {lat && lng ? (
                  <iframe
                    src={mapSrc}
                    width="100%"
                    height="100%"
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                ) : (
                  <div className="flex items-center justify-center h-full text-gray-400">
                    Location not available
                  </div>
                )}
              </div>

              {/* Info Box */}
              {deliveryData.is_home_delivery && (
                <div className="flex-1 rounded-xl h-[160px]  bg-[#ffefea] p-4 sm:p-6 lg:p-8">
                  <div className="flex flex-row justify-between items-center h-full gap-4 lg:gap-6">
                    <div className="flex flex-col justify-center text-start space-y-3 h-full">
                      <div>
                        <p className="text-[#FF6943] font-bold text-sm sm:text-md md:text-lg lg:text-xl">
                          Up to {deliveryData.delivery_upto} km
                        </p>
                        <h2 className="text-xs sm:text-sm md:text-md lg:text-lg text-gray-800 font-[Outfit]">
                          Delivery Area
                        </h2>
                      </div>
                      <div>
                        <p className="text-[#FF6943] font-bold text-sm sm:text-md md:text-lg lg:text-xl">
                          {currencySymbol} {deliveryData.delivery_charges}
                        </p>
                        <h2 className="text-xs sm:text-sm md:text-md lg:text-lg text-gray-800 font-[Outfit]">
                          Delivery Charges
                        </h2>
                      </div>
                    </div>

                    <div className="flex justify-center items-center h-full">
                      <img
                        src={delivery}
                        alt="Delivery Icon"
                        className="w-28 h-28 sm:w-32 sm:h-32 object-contain"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Delivery;
